import { Component } from 'react';
import { Auth } from 'aws-amplify';
import { hot } from 'react-hot-loader';

/**
 * This class is used to Logout user.
 */
export default hot(module)(
	class Logout extends Component {
		constructor(props) {
			super(props);
			this.signout();
		}

		/**
		 * This function will logout and send user to home page.
		 * @return {Promise<void>}
		 */
		async signout() {
			await Auth.signOut();
			localStorage.clear();
			window.location.href = '/';
		}

		render() {
			return '';
		}
	}
);
